import React from "react";
import $ from "jquery";
import Section from "../layouts/Section";

const NoticeLists = [
    {
        Id: "",
        Name: "",
        job_group__c: "",
        recruit_type__c: ""
    }
];

$.ajax({
    url: "https://90dhnop7pf.execute-api.ap-northeast-2.amazonaws.com/v1/recruit/recruit-form", // 요청이 전송될 URL 주소
    type: "GET", // http 요청 방식 (default: ‘GET’)
    dataType: "json", // 응답 데이터 형식 (명시하지 않을 경우 자동으로 추측)
    async: false
}).done(function (data) {
    if (data.records.length > 0) {
        NoticeLists.splice(0);
        for (let i = 0; i < data.records.length; i++) {
            const record = {
                Id: data.records[i].Id,
                Name: data.records[i].Name,
                job_group__c: data.records[i].job_group__c,
                recruit_type__c: data.records[i].recruit_type__c
            };
            NoticeLists.push(record);
        }
    } else {
        NoticeLists.splice(0);
    }
});

const RecruitList = () => {
    return (
        <>
            <Section width="6xl" space="md" className="flex flex-col justify-center">
                    <p className="my-2 text-body text-gray-500">
                        케이유융합소프트웨어연구센터
                    </p>
                    <h2 className="text-h2 font-bold sm:text-[36px] sm:leading-[46px]">
                        KUSRC와 함께 할<br />
                        멋진 동료를 찾고있어요!
                    </h2>
                    <div className="my-4 sm:my-10 space-y-4 text-left">
                        {NoticeLists.map(a => (
                            <>
                                <a
                                    href={"/recruit/jobs/detail/" + a.Id}
                                    key={a.Name}
                                    className="relative flex w-full flex-wrap items-start gap-y-2 rounded-lg sm:pr-4 py-6 sm:items-center sm:justify-between sm:gap-0"
                                >
                                    <div className="w-full text-lead font-bold">
                                        {a.Name}
                                    </div>
                                    <div className="mr-2 text-caption text-gray-600 sm:text-body">
                                        {a.job_group__c}
                                    </div>
                                    <div className="text-caption text-gray-600 sm:text-body">
                                        {a.recruit_type__c}
                                    </div>

                                    <div className="mt-2 w-full sm:mt-0 sm:ml-auto sm:w-auto">
                                        <button className="whitespace-nowrap rounded-md bg-accent px-4 py-2 text-caption font-semibold text-white transition duration-300 hover:bg-accent-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2">
                                            지원하기
                                        </button>
                                    </div>
                                </a>
                                <hr />
                            </>
                        ))}
                    </div>

                    {/* <div className="mt-20 flex justify-center space-x-1 dark:text-gray-100">
                        <button
                            title="previous"
                            type="button"
                            className="inline-flex h-8 w-8 items-center justify-center rounded-md py-0 "
                        >
                            <svg
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-4"
                            >
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </button>
                        <button
                            type="button"
                            title="Page 1"
                            className="inline-flex h-8 w-8 items-center justify-center rounded  bg-brand text-caption font-semibold text-white"
                        >
                            1
                        </button>
                        <button
                            type="button"
                            className="inline-flex h-8 w-8 items-center justify-center rounded text-caption  "
                            title="Page 2"
                        >
                            2
                        </button>
                        <button
                            type="button"
                            className="inline-flex h-8 w-8 items-center justify-center rounded  text-caption dark:border-gray-800 dark:bg-gray-900"
                            title="Page 3"
                        >
                            3
                        </button>
                        <button
                            type="button"
                            className="inline-flex h-8 w-8 items-center justify-center rounded  text-caption "
                            title="Page 4"
                        >
                            4
                        </button>
                        <button
                            title="next"
                            type="button"
                            className="inline-flex h-8 w-8 items-center justify-center rounded-md  py-0 "
                        >
                            <svg
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-4"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                    </div> */}
            </Section>
        </>
    );
};

export default RecruitList;
